import * as XLSX from 'xlsx';

/**
 * The Exception List template the card hands out: one sheet, its header row
 * only. Supplier Item identifies the product; SELL NET or Margin prices it.
 * Other filters narrow a row when
 * filled (docs/pricing/mass-renewal-upload.md, "Exception List").
 */
export const EXCEPTION_LIST_TEMPLATE_HEADERS = [
  'DIVISION',
  'ACCOUNT',
  'GROUP',
  'LOAD NUM',
  'QUOTE SPA',
  'Supplier Item',
  'SELL NET',
  'Margin',
  'Core Cost',
  'Add CC to Sell',
] as const;

const EXCEPTION_LIST_TEMPLATE_FILE_NAME = 'Exception List.xlsx';

const SHEET_NAME = 'Exceptions';

export function exceptionListTemplateWorkbook(): XLSX.WorkBook {
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.aoa_to_sheet([[...EXCEPTION_LIST_TEMPLATE_HEADERS]]),
    SHEET_NAME,
  );
  return workbook;
}

/** Saves the template through the browser's download. */
export function downloadExceptionListTemplate(): void {
  XLSX.writeFile(
    exceptionListTemplateWorkbook(),
    EXCEPTION_LIST_TEMPLATE_FILE_NAME,
  );
}
